export default __webpack_public_path__ + "static/media/dr_kiss_logo.552e5323.svg";